import { NavLayout } from "@cerebruminc/cerebellum";
import { useAtomValue } from "jotai";
import { styled } from "styled-components";

import { UserControls } from "src/components";
import { useSession } from "src/hooks";
import { highContrastThemeAtom } from "src/shame/shame-atoms";

import NavLogo from "./NavLogo";

const NavWrapper = styled.div<{ $highContrast?: boolean }>`
	box-shadow: ${({ $highContrast }) => ($highContrast ? "0 2px 20px 0 rgba(152, 158, 185, 0.13)" : "none")};
	position: fixed;
	width: 100%;
	z-index: 10;
`;

interface ComponentProps {
	navLogoAltText: string;
	navLogoComponent?: React.ReactNode;
	navLogoImageSource: string;
	showUserControls?: boolean;
}

// The Nav component is the high level "Assembly component" where all the other components are assembled into a nav bar.
// It also transforms the locally-named props of the other components into globally-named props (e.g. imageSource for NavLogo becomes navLogoImageSource).
export function Nav({
	navLogoAltText,
	navLogoComponent,
	navLogoImageSource,
	showUserControls = true,
}: Readonly<ComponentProps>) {
	const { session } = useSession();
	const isHighContrast = useAtomValue(highContrastThemeAtom);

	return (
		<NavWrapper id="header" $highContrast={isHighContrast}>
			<NavLayout>
				<NavLogo altText={navLogoAltText} imageSource={navLogoImageSource} logoComponent={navLogoComponent} />
				{session && showUserControls ? <UserControls /> : <div />}
			</NavLayout>
		</NavWrapper>
	);
}
